import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './lib/guard/auth.guard';
import { IntroGuard } from './lib/guard/intro.guard';
import { PublicGuard } from './lib/guard/public.guard';
import { ShopGuard } from './lib/guard/shop.guard';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { SelectUpiAppComponent } from './pages/kyc/bank-form/select-upi-app/select-upi-app.component';
import { FaqComponent } from './pages/user/faq/faq.component';
import { AddCatalogModalComponent } from './components/add-catalog-modal/add-catalog-modal.component';
import { ProductSearchComponent } from './pages/catelog/product-search/product-search.component';
import { B2bProductlistingComponent } from './pages/b2b/buy/b2b-productlisting/b2b-productlisting.component';
import { B2bStorelistingComponent } from './pages/b2b/buy/b2b-storelisting/b2b-storelisting.component';
import { PosLoginComponent } from './pages/pos/pos-login/pos-login.component';
import { RequestNewProductComponent } from './pages/catelog/custom-catalog/request-new-product/request-new-product.component';
import { CategoryModalComponent } from './pages/catelog/custom-catalog/category-modal/category-modal.component';
import { BulkUpdateComponent } from './pages/catelog/bulk-update/bulk-update.component';
import { UpdatedProductListComponent } from './pages/catelog/bulk-update/updated-product-list/updated-product-list.component';
import { MyQrComponent } from './pages/user/profile/my-qr/my-qr.component';
import { WalletPageComponent } from './pages/wallet-page/wallet-page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/user/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'profile/edit-profile-screen',
    redirectTo: 'edit-profile-screen',
    pathMatch: 'full'
  },

  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [IntroGuard, PublicGuard],
  },
  {
    path: 'selected-language',
    loadChildren: () => import('./pages/selected-language/selected-language.module').then((m) => m.SelectedLanguagePageModule),
  },
  {
    path: 'otp/:phone',
    loadChildren: () => import('./auth/otp/otp.module').then((m) => m.OtpPageModule),
    canActivate: [IntroGuard, PublicGuard],
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomePageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'wallet-page', component: WalletPageComponent
  },
  {
    path: 'kyc-form',
    loadChildren: () => import('./pages/kyc/kyc-form/kyc-form.module').then((m) => m.KycFormPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'bank-form',
    loadChildren: () => import('./pages/kyc/bank-form/bank-form.module').then((m) => m.BankFormPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'shop-address',
    loadChildren: () => import('./pages/shopDetails/shop-address/shop-address.module').then((m) => m.ShopAddressPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'shop-working-hours',
    loadChildren: () => import('./pages/shopDetails/shop-working-hours/shop-working-hours.module').then((m) => m.ShopWorkingHoursPageModule),
  },
  {
    path: 'my-catalog',
    loadChildren: () => import('./pages/catelog/my-catalog/my-catalog.module').then((m) => m.MyCatalogModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'browse-catalog',
    loadChildren: () => import('./pages/catelog/select-food/browse-catalog/browse-catalog.module').then((m) => m.BrowseCatalogPageModule),
  },
  {
    path: 'select-food',
    loadChildren: () => import('./pages/catelog/select-food/select-food.module').then((m) => m.SelectFoodPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'product-pricing',
    loadChildren: () => import('./pages/catelog/productProperties/product-pricing/product-pricing.module').then((m) => m.ProductPricingPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'productdiscount',
    loadChildren: () => import('./pages/catelog/productProperties/productdiscount/productdiscount.module').then((m) => m.ProductdiscountPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'product-grading',
    loadChildren: () => import('./pages/catelog/productProperties/product-grading/product-grading.module').then((m) => m.ProductGradingPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'custom-product',
    loadChildren: () => import('./pages/catelog/custom-catalog/custom-product/custom-product.module').then((m) => m.CustomProductModule),
    canActivate: [AuthGuard, ShopGuard]
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/order/order/order.module').then((m) => m.OrderPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },

  {
    path: 'order-details/:orderId/:orderStatus',
    loadChildren: () => import('./pages/order/order-details/order-details.module').then((m) => m.OrderDetailsPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'order-history',
    loadChildren: () => import('./pages/order/order-history/order-history.module').then((m) => m.OrderHistoryPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'package-list',
    loadChildren: () => import('./pages/payment/package-list/package-list.module').then((m) => m.PackageListPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'selling-mode',
    loadChildren: () => import('./pages/shopDetails/selling-mode/selling-mode.module').then((m) => m.SellingModePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'invoice/:info',
    loadChildren: () => import('./pages/payment/invoice/invoice.module').then((m) => m.InvoicePageModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('./support/faq/faq.module').then((m) => m.FaqPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/user/help/help.module').then((m) => m.HelpPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'edit-profile', component: EditProfileComponent
  },
  {
    path: 'product-search', component: ProductSearchComponent
  },
  {
    path: 'b2b-productlisting/:id', component: B2bProductlistingComponent
  },
  {
    path: 'b2b-storelisting/:id', component: B2bStorelistingComponent
  },
  {
    path: 'my-qr', component: MyQrComponent
  },
  {
    path: 'seller-profile/:id',
    loadChildren: () => import('./components/seller-profile/seller-profile.module').then(m => m.SellerProfilePageModule)
  },
  {
    path: 'subscription',
    loadChildren: () => import('./pages/payment/subscription/subscription.module').then((m) => m.SubscriptionPageModule),
    canActivate: [AuthGuard, ShopGuard],
  },
  {
    path: 'full-notification',
    loadChildren: () => import('./support/full-notification/full-notification.module').then(m => m.FullNotificationPageModule)
  },
  {
    path: 'order-quantity',
    loadChildren: () => import('./pages/catelog/productProperties/order-quantity/order-quantity.module').then((m) => m.OrderQuantityPageModule),
  },
  {
    path: 'customer-detail/:customerId/:userPhoneNumber/:userStatus',
    loadChildren: () => import('./pages/crm/customer-detail/customer-detail.module').then(m => m.CustomerDetailPageModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('./pages/crm/customers/customers.module').then(m => m.CustomersPageModule)
  },
  {
    path: 'gst',
    loadChildren: () => import('./pages/user/gst/gst.module').then(m => m.GstPageModule)
  },
  {
    path: 'select-upi-app',
    component: SelectUpiAppComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'faq',
    component: FaqComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'select-category',
    component: AddCatalogModalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos-login',
    component: PosLoginComponent
  },
  {
    path: 'cart',
    loadChildren: () => import('./pages/pos/cart/cart.module').then(m => m.CartPageModule)
  },
  {
    path: 'productlisting',
    loadChildren: () => import('./pages/pos/productlisting/productlisting.module').then(m => m.ProductlistingPageModule)
  },
  {
    path: 'payment-screen',
    loadChildren: () => import('./pages/pos/payment-screen/payment-screen.module').then(m => m.PaymentScreenPageModule)
  },
  {
    path: 'payment-success',
    loadChildren: () => import('./pages/pos/payment-success/payment-success.module').then(m => m.PaymentSuccessPageModule)
  },
  {
    path: 'buy',
    loadChildren: () => import('./pages/b2b/buy/buy.module').then(m => m.BuyPageModule)
  },
  {
    path: 'b2b-cart',
    loadChildren: () => import('./pages/b2b/b2b-cart/b2b-cart.module').then(m => m.B2bCartPageModule)
  },
  {
    path: 'b2b-payment-screen',
    loadChildren: () => import('./pages/b2b/b2b-payment-screen/b2b-payment-screen.module').then(m => m.B2bPaymentScreenPageModule)
  },
  {
    path: 'b2b-payment-success',
    loadChildren: () => import('./pages/b2b/b2b-payment-success/b2b-payment-success.module').then(m => m.B2bPaymentSuccessPageModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./pages/b2b/orders/orders.module').then(m => m.OrdersPageModule)
  },
  {
    path: 'b2b-orders-detail/:id',
    loadChildren: () => import('./pages/b2b/orders/b2b-orders-detail/b2b-orders-detail.module').then(m => m.B2bOrdersDetailPageModule)
  },
  {
    path: 'track-order/:id',
    loadChildren: () => import('./pages/b2b/orders/track-order/track-order.module').then(m => m.TrackOrderPageModule)
  },
  { path: 'add-product', component: RequestNewProductComponent, canActivate: [AuthGuard], },
  { path: 'select-food-category', component: CategoryModalComponent, canActivate: [AuthGuard], },

  {
    path: 'bulk-update',
    component: BulkUpdateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'updated-productlist/:id',
    component: UpdatedProductListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/user/setting/setting.module').then(m => m.SettingPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationPageModule)
  },
  {
    path: 'deactivation-reason',
    loadChildren: () => import('./pages/delete-account/deactivation-reason/deactivation-reason.module').then(m => m.DeactivationReasonPageModule)
  },
  {
    path: 'account-deleted',
    loadChildren: () => import('./pages/delete-account/account-deleted/account-deleted.module').then(m => m.AccountDeletedPageModule)
  },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
